
import { Movie } from "@/types/movie";
import { useMovieDialogContext } from "@/context/dialog/MovieDialogContext";

/**
 * Custom hook to manage movie dialog state
 */
export const useMovieDialog = () => {
  const { state, dispatch, expandedMovie } = useMovieDialogContext();
  
  return {
    expandedMovieId: state.expandedId,
    expandedMovie,
    isLoading: state.isLoading,
    loadError: state.loadError,
    setExpandedMovieId: (id: string | null) => {
      if (id) {
        dispatch({ type: "OPEN_BY_ID", payload: id });
      } else {
        dispatch({ type: "CLOSE" });
      }
    },
    setExpandedMovie: (movie: Movie | null) => {
      if (movie) {
        dispatch({ type: "OPEN_BY_ENTITY", payload: movie });
      } else {
        dispatch({ type: "CLOSE" });
      }
    },
    closeDialog: () => dispatch({ type: "CLOSE" })
  };
};
